import { serializable, alias, primitive } from 'serializr';

export class Library {
  @serializable(alias('name', primitive()))
    name?: string;

  @serializable(alias('author', primitive()))
    author?: string;
}
